<script>
  import { _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import { link } from 'svelte-spa-router';
  import { api } from '../../helpers/index.js';
  import { notices_list } from './../pages/Notice/stores';
  import { info_client, client } from '../stores';

  import Modal from "./Modal.svelte";
  import active from 'svelte-spa-router/active'
  import ToggleButton from '../custom/ToggleButton.svelte';
  import ModalNoticeList from '../pages/Notice/ModalNoticeList.svelte';
  import { getBaseApiUrl } from '../../api/base.js';

  const name_url = getBaseApiUrl();

  let isShowShop = false;

  $: isShowShop = $info_client.flow?.shop_icon_status === 'available' || $client.flow?.settings.shop_icon_status === 'available'

  //для модального окна
  let showModal = false;
  let show = false;
  let filterStep = 0;

  // Notice Modal Filters State
  let showFeedPT = false;
  let showFeedPP = false;

  let allSettings = {};

  const filters = {
    notification_reply_to_comment: true,
    notification_comment_like: true,
    notification_wiki: true,
  };

  const filtersPT = {
    notification_video: true,
    notification_article: true,
    notification_training: true,
    notification_tasks: true,
    notification_announcement: true,
    notification_webinar: true,
  };

  const filtersPP = {
    rpp_notification_video: true,
    rpp_notification_article: true,
    rpp_notification_training: true,
    rpp_notification_tasks: true,
    rpp_notification_announcement: true,
    rpp_notification_webinar: true,
  };

  $: checkAllPT(filtersPT);
  $: checkAllPP(filtersPP);

  const checkAllPT = data => {
    showFeedPT = Object.values(data).some(el => el);
  }

  const checkAllPP = data => {
    showFeedPP = Object.values(data).some(el => el);
  }

  const selectAllPT = () => {
    Object.entries(filtersPT).forEach(([key]) => {
      filtersPT[key] = showFeedPT;
    });
  }

  const selectAllPP = () => {
    Object.entries(filtersPP).forEach(([key]) => {
      filtersPP[key] = showFeedPP;
    });
  }

  const resetFilters = () => {
    filterStep = 0;
    syncFilters();
  }

  const backHandler = () => {
    if (filterStep === 1) {
      resetFilters();
    } else if (filterStep === 2) {
      filterStep = 1;
    } else if (filterStep === 3 || filterStep === 4) {
      filterStep = 2;
    }
  }


  const hideNoticeModal = async () => {
    show = false;

    resetFilters();
    
    const removedIds = $notices_list
      .filter(({ is_hidden }) => is_hidden)
      .map(({ id }) => id);

    if (!removedIds.length) {
      return;
    }

    await api(
      '/api/v1/notice/delete-list/',
      'DELETE',
      JSON.stringify(removedIds),
      true,
    ); 
  }

  const openFilters = () => {
    filterStep = 1;
  }

  const saveFilters = async () => {
    const params = {
      ...filters,
      ...filtersPT,
      ...filtersPP,
    };

    allSettings = await api(
      '/api/v1/jwt-client/notice-settings-update/',
      'PUT',
      JSON.stringify(params),
      true,
    );

    filterStep = 0;
  }

  const syncFilters = () => {
    Object.entries(allSettings).forEach(([key, value]) => {
      if (filters.hasOwnProperty(key)) {
        filters[key] = value;
      }

      if (filtersPT.hasOwnProperty(key)) {
        filtersPT[key] = value;
      }

      if (filtersPP.hasOwnProperty(key)) {
        filtersPP[key] = value;
      }
    });
  }

  const openModal = () => {
    show = true;

    info_client.update((value) => {
      return {
        ...value, 
        not_read_notice: false,
      };
    })

    syncFilters();
  }

  onMount(() => {
    allSettings = $info_client.settings || {};

    syncFilters();
  });
</script>

<!-- для пользователя -->

<div class="header">
  <div class="container">
    <div class="firstsecond">
      <div class="header__brand">
        <a href={name_url} class="brand__name text-bold">Physical Transformation</a>
      </div>  
      <div class="header__navigation">
        <nav class="client-menu">
          <ul class="client-menu__list">
            <li class="client-menu__item">
              <a href={name_url}
                class="client-menu__link text-grey text-bold">
                <i class="icon-home"></i>
              </a>
            </li>

            {#if !$info_client.is_staff}
              <li class="client-menu__item">
                <a href={name_url+"client/progress/"}
                class="client-menu__link text-grey text-bold">
                  <i class="icon-my-progress"></i>
                <span class="icon_name icon_name--hidden">{$_('headerProgress')}</span>
                </a>
              </li>
            
              <li class="client-menu__item">
                <a href={name_url+'client/board/'}
                class="client-menu__link text-grey text-bold client-menu__link--new-message">
                  <i class="icon-comment-dots"></i>
                  <span class="icon_name icon_name--hidden">{$_('headerTheme')}</span>
                </a>
              </li>

              <li>
                <span class="line"></span>
              </li>

              <li class="client-menu__item">
                <a 
                  href="/" 
                  class="client-menu__link text-grey text-bold"
                  use:link
                  use:active={{path: '/*', className: 'active'}}
                >
                  <i id="icon__content" class="icon-ph_life_only_icon_without_bg_small_bold"></i>
                <span class="icon_name content">{$_('headerContent')}</span>
                </a>
              </li>

              {#if isShowShop}
                <li class="client-menu__item">
                  <a
                    href={name_url+'jwt-auth/redirect-refresh-token/to-shop/'}
                    class="client-menu__link text-grey text-bold"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#BDBFC4" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.5709 7.21729C18.9007 7.21729 20.2955 8.17439 20.7884 10.5001L21.5974 17.018C22.1925 21.2675 19.8027 22.9999 16.5945 22.9999H7.87205C4.6546 22.9999 2.19036 21.8035 2.85989 17.018L3.6782 10.5001C4.09666 8.10739 5.538 7.21729 6.88636 7.21729H17.5709ZM8.20809 10.7203C7.69452 10.7203 7.27819 11.1488 7.27819 11.6774C7.27819 12.206 7.69452 12.6345 8.20809 12.6345C8.72166 12.6345 9.13799 12.206 9.13799 11.6774L9.13075 11.5573C9.07336 11.0854 8.68215 10.7203 8.20809 10.7203ZM16.212 10.7203C15.6984 10.7203 15.2821 11.1488 15.2821 11.6774C15.2821 12.206 15.6984 12.6345 16.212 12.6345C16.7255 12.6345 17.1419 12.206 17.1419 11.6774C17.1419 11.1488 16.7255 10.7203 16.212 10.7203Z"/>
                      <path
                        d="M12.2191 3.86957C10.6343 3.86957 9.34955 5.15431 9.34955 6.73913C9.34955 6.90151 9.36303 7.06074 9.38895 7.21576L9.38922 7.21739H6.88648C6.75874 7.21739 6.63016 7.22538 6.5017 7.24188C6.48732 7.07621 6.47998 6.90853 6.47998 6.73913C6.47998 3.5695 9.04948 1 12.2191 1C15.3887 1 17.9582 3.5695 17.9582 6.73913C17.9582 6.90846 17.9509 7.07609 17.9365 7.24169C17.8147 7.22539 17.6926 7.21739 17.571 7.21739H15.049C15.0751 7.06186 15.0887 6.90208 15.0887 6.73913C15.0887 5.15431 13.8039 3.86957 12.2191 3.86957Z"/>
                    </svg>
                    <span class="icon_name" style="display: flex">{$_('headerStore')}</span>
                  </a>
                </li>
              {/if}
            {/if}

            <!-- {#if $info_client.editor}
              <li class="client-menu__item">
                <a 
                  href="/editor/list" 
                  class="client-menu__link text-grey text-bold"
                  use:link
                  use:active={{path: '/editor/*', className: 'active'}}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.98514 6.61545L4.10247 7.35622H4.10247L3.98514 6.61545ZM7.4487 3.15189L8.18947 3.26922V3.26922L7.4487 3.15189ZM15.7824 17.5377L15.3416 16.9309L15.7824 17.5377ZM16.7042 16.6159L16.0975 16.175L16.7042 16.6159ZM3.29576 16.6159L3.90252 16.175L3.29576 16.6159ZM4.21756 17.5377L4.6584 16.9309L4.21756 17.5377ZM4.21756 2.46251L3.77672 1.85575L4.21756 2.46251ZM3.29576 3.38431L2.689 2.94347L3.29576 3.38431ZM15.7824 2.46251L15.3416 3.06927L15.7824 2.46251ZM16.7042 3.38431L16.0975 3.82515L16.7042 3.38431ZM7.5 1.69086L7.47432 0.941295L7.5 1.69086ZM2.52411 6.66675L1.77455 6.64107L2.52411 6.66675ZM7.5 10.0834C7.08579 10.0834 6.75 10.4192 6.75 10.8334C6.75 11.2476 7.08579 11.5834 7.5 11.5834V10.0834ZM12.5 11.5834C12.9142 11.5834 13.25 11.2476 13.25 10.8334C13.25 10.4192 12.9142 10.0834 12.5 10.0834V11.5834ZM9.25 13.3334C9.25 13.7476 9.58579 14.0834 10 14.0834C10.4142 14.0834 10.75 13.7476 10.75 13.3334H9.25ZM10.75 8.33341C10.75 7.9192 10.4142 7.58341 10 7.58341C9.58579 7.58341 9.25 7.9192 9.25 8.33341H10.75ZM4.10247 7.35622C6.20627 7.02301 7.85626 5.37302 8.18947 3.26922L6.70793 3.03457C6.47638 4.49653 5.32978 5.64313 3.86782 5.87468L4.10247 7.35622ZM1.75 9.16675V10.8334H3.25V9.16675H1.75ZM18.25 10.8334V9.16675H16.75V10.8334H18.25ZM10 19.0834C11.5457 19.0834 12.7652 19.0844 13.7331 18.9796C14.715 18.8732 15.5265 18.6507 16.2233 18.1444L15.3416 16.9309C14.9431 17.2204 14.4258 17.3958 13.5715 17.4883C12.7032 17.5824 11.5791 17.5834 10 17.5834V19.0834ZM16.75 10.8334C16.75 12.4125 16.749 13.5366 16.6549 14.4049C16.5623 15.2592 16.387 15.7765 16.0975 16.175L17.311 17.0567C17.8173 16.3599 18.0398 15.5484 18.1462 14.5665C18.251 13.5986 18.25 12.3791 18.25 10.8334H16.75ZM16.2233 18.1444C16.6407 17.8412 17.0077 17.4741 17.311 17.0567L16.0975 16.175C15.8867 16.4651 15.6317 16.7202 15.3416 16.9309L16.2233 18.1444ZM1.75 10.8334C1.75 12.3791 1.74897 13.5986 1.85383 14.5665C1.96022 15.5484 2.18275 16.3599 2.689 17.0567L3.90252 16.175C3.61301 15.7765 3.43766 15.2592 3.34511 14.4049C3.25103 13.5366 3.25 12.4125 3.25 10.8334H1.75ZM10 17.5834C8.42091 17.5834 7.29683 17.5824 6.4285 17.4883C5.57421 17.3958 5.05688 17.2204 4.6584 16.9309L3.77672 18.1444C4.47352 18.6507 5.28502 18.8732 6.26693 18.9796C7.23481 19.0844 8.45432 19.0834 10 19.0834V17.5834ZM2.689 17.0567C2.99226 17.4741 3.35932 17.8412 3.77672 18.1444L4.6584 16.9309C4.36834 16.7202 4.11326 16.4651 3.90252 16.175L2.689 17.0567ZM3.77672 1.85575C3.35932 2.15901 2.99226 2.52607 2.689 2.94347L3.90252 3.82515C4.11326 3.53509 4.36834 3.28001 4.6584 3.06927L3.77672 1.85575ZM10 2.41675C11.5791 2.41675 12.7032 2.41778 13.5715 2.51185C14.4258 2.60441 14.9431 2.77976 15.3416 3.06927L16.2233 1.85575C15.5265 1.3495 14.715 1.12697 13.7331 1.02058C12.7652 0.915719 11.5457 0.916748 10 0.916748V2.41675ZM18.25 9.16675C18.25 7.62107 18.251 6.40156 18.1462 5.43368C18.0398 4.45176 17.8173 3.64027 17.311 2.94347L16.0975 3.82515C16.387 4.22363 16.5623 4.74096 16.6549 5.59525C16.749 6.46358 16.75 7.58765 16.75 9.16675H18.25ZM15.3416 3.06927C15.6317 3.28001 15.8867 3.53509 16.0975 3.82515L17.311 2.94347C17.0077 2.52607 16.6407 2.15901 16.2233 1.85575L15.3416 3.06927ZM10 0.916748C9.03005 0.916748 8.19352 0.916654 7.47432 0.941295L7.52568 2.44042C8.21372 2.41684 9.02174 2.41675 10 2.41675V0.916748ZM7.47432 0.941295C5.91157 0.994837 4.72962 1.16343 3.77672 1.85575L4.6584 3.06927C5.21318 2.6662 5.98145 2.49332 7.52568 2.44042L7.47432 0.941295ZM6.75 1.69085C6.74999 2.47647 6.74718 2.7868 6.70793 3.03457L8.18947 3.26922C8.25175 2.87597 8.24999 2.42151 8.25 1.69086L6.75 1.69085ZM3.25 9.16675C3.25 8.18849 3.25009 7.38047 3.27367 6.69243L1.77455 6.64107C1.74991 7.36027 1.75 8.19679 1.75 9.16675H3.25ZM3.27367 6.69243C3.32657 5.1482 3.49945 4.37993 3.90252 3.82515L2.689 2.94347C1.99668 3.89636 1.82809 5.07832 1.77455 6.64107L3.27367 6.69243ZM2.52411 7.41675C3.25476 7.41674 3.70922 7.4185 4.10247 7.35622L3.86782 5.87468C3.62005 5.91393 3.30973 5.91674 2.5241 5.91675L2.52411 7.41675ZM7.5 11.5834H12.5V10.0834H7.5V11.5834ZM10.75 13.3334V8.33341H9.25V13.3334H10.75Z" fill="#2B50ED"/>
                  </svg>
                  <span class="icon_name content" style="display: flex">{$_('editor')}</span>
                </a>
              </li>
            {/if} -->
          </ul>
        </nav>
      </div> 
    </div>
    <div class="account">

    <!-- чтобы не было возможности открыть модальное окно, если их нет -->
    {#if sessionStorage.getItem("sumOfNotices") !== '0'}
      <div 
        class="alarm text-grey alarm--new-message"
        href="#popup_notice"
        style={'cursor: pointer'}
        on:click={()=> openModal()}
      >
        <i 
          class="icon-bell-empty"
          class:not_read_notice={$info_client.not_read_notice} 
        />
      </div>
    {:else}
      <div class="alarm text-grey alarm--new-message">
        <i class="icon-bell-empty" />
      </div>
    {/if}

    {#if show}
      <Modal on:close={hideNoticeModal}>
        <div 
          class="popup_notice" 
          slot="header"
        >
          <div class="popup-header">
            <div
              class="popup_header-text text-bold flex justify-center items-center"
              on:click|stopPropagation={() => backHandler()}
              style:visibility={filterStep === 0 ? 'hidden' : 'initial'}
            >
              <i class="icon-arrow-left-v2" /> {$_('Back')}
            </div>

            <div class="popup_notice_title text-bold text-center">
              {#if (filterStep === 0)}
                {$_('Notifications')}
              {:else if (filterStep === 1)}
                {$_('filters')}
              {:else if (filterStep === 2)}
                {$_('publication')}
              {:else if (filterStep === 3)}
                {$_('feed')}
              {:else if (filterStep === 4)}
                {$_('wiki')}
              {/if}
            </div>

            {#if filterStep !== 0}
              <div class="popup_header-text text-bold text-right" on:click|stopPropagation={saveFilters}>
                {$_('save')}
              </div>
            {:else}
              <div class="popup_header-text text-bold text-right" on:click|stopPropagation={openFilters}>
                <i class="icon-settings" />
                <span class="filters-text">
                  {$_('filters')}
                </span>
              </div>
            {/if}
          </div>

          <div class="divider" style="margin: 0"/>

          <div class="popup-body" on:click|stopPropagation>
            {#if filterStep === 0}
              <ModalNoticeList isGreenFlow={$info_client?.flow?.is_green} on:hide-modal={() => show = false}/>
            {:else if filterStep === 1}
              <div class="filters">
                <div class="filters__item filters__item--pointer" on:click={() => filterStep = 2}>
                  <div class="filters__item-title text-bold">
                    {$_('publication')}
                  </div>

                  <div class="filters__item-next">
                    <i class="icon-arrow-rounded"></i>
                  </div>
                </div>

                <div class="filters__item">
                  <div class="filters__item-title text-bold">
                    {$_('showLikes')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filters.notification_comment_like}/>
                  </div>
                </div>

                <div class="filters__item">
                  <div class="filters__item-title text-bold">
                    {$_('showAnswers')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filters.notification_reply_to_comment}/>
                  </div>
                </div>
              </div>
            {:else if (filterStep === 2)}
              <div class="filters">
                <div class="filters__item filters__item--pointer" on:click={() => filterStep = 3}>
                  <div class="filters__item-title text-bold">
                    {$_('feed')}
                  </div>

                  <div class="filters__item-next">
                    <i class="icon-arrow-rounded"></i>
                  </div>
                </div>

                <div class="filters__item filters__item--pointer" on:click={() => filterStep = 4}>
                  <div class="filters__item-title text-bold">
                    {$_('wiki')}
                  </div>

                  <div class="filters__item-next">
                    <i class="icon-arrow-rounded"></i>
                  </div>
                </div>
              </div>
            {:else if (filterStep === 3)}
              <div class="filters">
                <div class="filters__item filters__item--narrow">
                  <div class="filters__item-title text-bold">
                    {$_('feedPT')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={showFeedPT} on:change={() => selectAllPT()}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('video')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_video}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('article')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_article}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('training')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_training}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('tasks')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_tasks}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('announcement')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_announcement}/>
                  </div>
                </div>

                <div class="filters__item filters__item--sub-filter">
                  <div class="filters__item-title text-bold">
                    {$_('webinar')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filtersPT.notification_webinar}/>
                  </div>
                </div>
              </div>

              <div class="divider"/>

              {#if $info_client.is_paid_rpp_current_flow}
                <div class="filters">
                  <div class="filters__item filters__item--narrow">
                    <div class="filters__item-title text-bold">
                      {$_('feedPP')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={showFeedPP} on:change={() => selectAllPP()}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('video')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_video}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('article')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_article}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('training')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_training}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('tasks')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_tasks}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('announcement')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_announcement}/>
                    </div>
                  </div>

                  <div class="filters__item filters__item--sub-filter">
                    <div class="filters__item-title text-bold">
                      {$_('webinar')}
                    </div>

                    <div class="filters__item-toggle">
                      <ToggleButton bind:value={filtersPP.rpp_notification_webinar}/>
                    </div>
                  </div>
                </div>
              {/if}
            {:else if (filterStep === 4)}
              <div class="filters">
                <div class="filters__item">
                  <div class="filters__item-title text-bold">
                    {$_('publicationWiki')}
                  </div>

                  <div class="filters__item-toggle">
                    <ToggleButton bind:value={filters.notification_wiki}/>
                  </div>
                </div>
              </div>
            {/if}
          </div>
        </div>
      </Modal>
    {/if}

    <div class="bottom">
      <button on:click="{() => showModal = true}"
        class="account-info" type="button" href="#popup" >
        <span class="account-info__name">{$info_client.first_name} {$info_client.last_name}</span>
        {#if $info_client.avatar_url !== ""}
        <img class="account-info__image" src={$info_client.avatar_url} alt width="36" height="36">
        {:else}
        <img class="account-info__image" src="/static/avatar.webp" alt width="36" height="36">
        {/if}
        {#if !$info_client.is_staff}
        {#if showModal === false}
        <i class="account-info__icon icon-arrow_bottom"></i>
        {:else}
        <i class="account-info__icon icon-arrow_bottom" style="transform: rotate(180deg)"></i>
        {/if}
        {:else}
        <i class="account-info__icon icon-arrow_bottom" style={'visibility:hidden'}></i>
        {/if}
      </button>
    </div>
  </div>
</div>
{#if showModal}
  {#if !$info_client.is_staff}
  <Modal on:close="{() => showModal = false}">
  <div  class="popup" slot="header">
    <div class="popup__body">
      <div class="popup__content">
        <a class="popup__item"
        href={name_url+'client/page_client_profile/'}>
          <i class="icon-account"></i>
          <span>{$_('popupProfile')}</span>
        </a>
      
        <div class="popup__line"></div>
        <a class="popup__item popup__item-last"
        href='/logout/' use:link>
          <i class="icon-exit"></i>
          <span>{$_('popupLogOut')}</span>
        </a>
      </div>
    </div>
  </div>
  </Modal>
  {/if}
{/if}

</div>

<style lang="scss">
  .header {
    position: fixed; 
    left: 0; top: 0;
    width: 100%;
    height: 90px;
    box-shadow: 0px 1px 12px rgba(48, 51, 61, 0.18);
    background-color:white; 
    z-index: 9999; 

    @media (max-width: 576px) {
      height: 88px;
    }
  }

  .divider {
    margin: 0 18px;
    border: 0.5px solid #F3F3F4;
  }

  .filters {
    padding: 0 20px 16px 20px;

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 0;
      border-top: 1px solid #F3F3F4;

      &:first-child {
        border-top: none;
      }

      &:last-child {
        padding-bottom: 3px;
      }

      &--pointer {
        cursor: pointer;
      }

      &--narrow {
        margin-top: 16px;
        padding: 3px 0;
      }

      &--sub-filter {
        margin-top: 8px;
        padding: 3px 0;
        border-top: none;

        .filters {
          &__item-title {
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }

    &__item-title {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      color: #30333D;
    }

    &__item-next {
      > i {
        font-size: 16px;
        color: #576CED;
      }
    }

    &__item-toggle {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .popup-header {
    padding: 20px 20px 13px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .popup-header div {
    white-space: nowrap;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .popup_header-text {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0em;
    color: #576CED;
    cursor: pointer;

    @media (max-width: 576px) {
      .filters-text {
        display: none;
      }
    }
  }

  .popup_header-text i {
    margin-right: 9px;
  }

  .icon-arrow-left-v2 {
    font-size: 24px;
    margin-right: 2px!important;
  }

  .icon-bell-empty {
    font-size: 18px;
    display: flex;
    position: relative;
  }

  .icon-bell-empty.not_read_notice::after {
    content: '';
    position: absolute;
    background-color: red;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    right: 3px;
    top: 0;
    border: 2px solid white;
  }

.container { 
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
}

.firstsecond {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.brand__name {
  font-style: normal;
  font-size: 18px;
  line-height: 26px;
  color: #30333D;
  text-decoration: none;
  outline: none;
}

    /* 2 блок */

.header__navigation {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.client-menu__list { 
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  list-style-type: none;
}
    
.client-menu__link {
  display: flex;
  justify-content: center; 
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  border: 2px solid #E0E8F6;
  border-radius: 30px;
  padding: 16px;
  margin-left: 10px;
  cursor: pointer;
  opacity: .8;
}

.client-menu__link:hover{
  color: #244ec2;
  border: 2px solid #244ec2;

  > svg {
    fill: #244ec2;
  }
}

.icon_name {
  padding-left: 8px;
  word-break: initial;
  white-space: nowrap;

  &--hidden {
    display: block;
    @media (max-width: 1290px){
      display: none;
    }
  }
}

.line { 
  content: " ";
  background: #E0E8F6;
  width: 1px;
  height: 50px;
  float: left;
  margin-left: 20px;
  margin-right: 10px;
}

#icon__content {
  color:#2B50ED;
}

.content {
  color:#2B50ED;
}

    /* 3 блок */
.account {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.alarm {
  padding-right: 40px;
  display: flex;
  align-items: center;
}

.account-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background: white;
  cursor: pointer;
}

.account-info__name {
  font-size: 16px;
  line-height: 23px;
}

.account-info__image {
  width: 34px;
  height: 34px;
  border-radius: 100px;
  margin-left: 16px;
  margin-right: 3px;
}

.account-info__icon {
  color: #30333D;
}

/* popup */

.popup{
  position: absolute;
	right: 5%;
  top:15%; 
  transform: translate(-5%,-5%);
	overflow: none;
	margin: 0em;
  z-index: 9999;
}

.popup__content {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 200px;
  height: 90px;
  box-shadow: 0px 2px 10px rgba(48, 51, 61, 0.26);
  border-radius: 10px;
  padding: 20px;
}

.popup__item {
  white-space: nowrap;
  border: 0;
  font-size: 16px;
  line-height: 23px;
  color: #30333D;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  margin-top: 10px;
}

.popup__line {
  background-color: #E0E8F6;
  height: 1px;
  margin-top: 10px;
}

.popup__item:hover {
  color: #2B50ED;
}

.popup__item-last:hover {
  color: #FA624B;;
}

/* для модального окна уведомлений */
.popup_notice{
  position: absolute;
	right: 10%; 
  top: 0;
	overflow-y: scroll;
	margin-top: 80px;
  z-index: 9999;
  box-shadow: 0px 2px 10px rgba(48, 51, 61, 0.26);
  border-radius: 10px;
  background-color: white;
  width: 516px;
  min-height: 228px;
  max-height: 495px;
}

.popup_notice_title{
  position: relative;
  font-size: 16px;
  line-height: 23px;
  color: #30333D;
  text-align: center;
}

.line { 
  content: " ";
  background: #E0E8F6;
  width: 100%;
  height: 1px;
  float: left;
  margin: 12px 0 12px 0;
  }

@media (max-width: 1290px){
  .container { 
    display: flex;
    flex-direction: row;
    padding: 0 30px 0 30px;
  }
}

@media (max-width: 768px){
  .popup-header {
    padding: 16px 15px 12px 15px;
  }

  .filters {
    padding: 0 15px 16px 15px;
  }

  .divider {
    margin: 0 15px;
  }

  .header__navigation {
    display: none;
  }
  .container { 
    display: flex;
    align-items: center;
    padding: 20px 30px 0 30px;
  }
  .popup_notice{
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    z-index: 9999;
    box-shadow: 0px 2px 10px rgb(48 51 61 / 26%);
    border-radius: 0;
    background-color: white;
    width: 100%;
    height: calc(100% - 140px) !important;
    max-height: initial;
    padding: 0;
  }

  .popup__content {
    width: 180px;
    height: 90px;
  }
}

@media (max-width: 576px){
  .container { 
    padding: 20px 18px 0 18px;
  }
  .account {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .account-info__name {
    display: none;
  }
  .alarm {
    padding: 5px 0 0 0;
  }
  .popup__content {
    width: 160px;
    height: 90px;
  }
}

@media (max-width: 500px){
  .container { 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .header__brand {
    margin-left: 0;
  }
  .brand__name {
    font-size: 16px;
  }
  .popup__content {
    width: 140px;
    height: 90px;
  }
  .popup{
    right: 5%;
    top:15%; 
    transform: translate(-5%,-5%);
  } 
}
@media (max-width: 320px){
   .container { 
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 20px 0 0 0;
  }
    .account-info__image {
    margin-left: 0;
    margin-right: 0;
  } 
}
</style>
